/*
* Broadcast Theme — custom JS. Modules: (1) Bold options restyle + visual
* selectors, (2) live price-with-extras, (3) conditional options engine,
* (4) cart line strike guard, (5) cart UX (count refresh + ATC spinner),
* (6) variant-aware tone filtering.
*/


(function() {
  // Judge.me v3 renders stars natively; no font patch needed.
})();


/* ---- Shared product data prefetch (Broadcast 8.1.1 omits product JSON in DOM) ---- */
(function () {
  var m = location.pathname.match(/\/products\/([^/?#]+)/);
  if (!m) return;
  fetch('/products/' + m[1] + '.js')
    .then(function (r) { return r.json(); })
    .then(function (p) { if (p && p.variants) window.__bfProdJSON = p; });
})();



/* ============================================================================
 * BF — Bold Product Options restyle + visual selectors  (v3.5)
 * ========================================================================== */
(function () {
  'use strict';

  function injectCSS() {
    if (document.getElementById('bf-bold-restyle-css')) return;
    var st = document.createElement('style');
    st.id = 'bf-bold-restyle-css';
    st.textContent = [
      '.product__wrapper__inner{margin-left:auto !important;margin-right:auto !important}',
      '.bold_options,.bold_options_loaded{border:0 !important;background:transparent !important;padding:0 !important}',
      '.bold_option,.bold_option_dropdown,.bold_option_textbox,.bold_option_textarea,.bold_option_swatch,.bold_option_radio{border:0 !important;background:transparent !important;padding:0 !important}',
      '.bold_option:not(:empty){margin-bottom:18px !important}',
      '.bold_option_title{display:block !important;background:transparent !important;background-image:none !important;font-weight:700 !important;font-size:12px !important;letter-spacing:.08em;text-transform:uppercase;color:#5a3e6b !important;margin:0 0 4px 0 !important;padding:0 !important}',
      '.bold_option_dropdown .bold_option_element{display:block !important;margin-left:0 !important;width:100%}',
      ".bold_option_dropdown .bold_option_element select{-webkit-appearance:none !important;-moz-appearance:none !important;appearance:none !important;width:100% !important;box-sizing:border-box !important;padding:13px 40px 13px 14px !important;border:1.5px solid #e0dbd8 !important;border-radius:8px !important;background-color:#fff !important;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='none' stroke='%235a3e6b' stroke-width='2' d='M1 1l5 5 5-5'/%3E%3C/svg%3E\") !important;background-repeat:no-repeat !important;background-position:right 14px center !important;font-size:15px !important;color:#333 !important;cursor:pointer;height:auto !important}",
      '.bold_option_dropdown select:focus{outline:none !important;border-color:#5a3e6b !important}',
      '.bold_option_textbox .bold_option_element,.bold_option_textarea .bold_option_element{display:block !important;margin-left:0 !important;width:100%}',
      '.bold_option_textbox .bold_option_element input[type=text],.bold_option_textarea .bold_option_element textarea{width:100% !important;box-sizing:border-box !important;padding:13px 14px !important;border:1.5px solid #e0dbd8 !important;border-radius:8px !important;font-size:15px !important;height:auto !important;background:#fff !important;margin:0 !important}',
      '.bold_option_textbox input:focus,.bold_option_textarea textarea:focus{outline:none;border-color:#5a3e6b !important}',
      '.bold_help_text{margin-top:4px !important;color:#8a8a8a !important;line-height:1.4;font-style:italic}',
      '.bold_option_value_price{color:#5a3e6b !important;font-weight:600}',
      '.product__tax{display:none !important}',
      '.select-popout__item--current .select-popout__option{color:inherit !important}',
      '.radio__legend{border-radius:0 !important}',
      '.select-popout__toggle{border:revert !important}',
      '.selector-wrapper{border:0 !important;border-radius:0 !important;min-width:0 !important;margin:0 0 18px 0 !important;padding:0 !important}',
      '.selector-wrapper .select__fieldset{display:block !important;height:auto !important;border:0 !important;padding:0 !important;margin:0 !important}',
      '.selector-wrapper .radio__legend{background:transparent !important;background-color:transparent !important;color:#5a3e6b !important;display:block !important;flex:none !important;padding:0 !important;margin:0 0 4px 0 !important;border-radius:0 !important}',
      '.selector-wrapper .radio__legend .radio__legend__label,.selector-wrapper .radio__legend span.radio__legend__label{color:#5a3e6b !important;font-size:12px !important;font-weight:700 !important;letter-spacing:.08em !important;text-transform:uppercase !important;padding:0 !important;margin:0 !important}',
      '.selector-wrapper .select-popout{flex:none !important;display:block !important;width:100% !important;height:auto !important;margin:0 !important}',
      '.selector-wrapper .select-popout.bfv-pop-hidden{display:none !important}',
      '.selector-wrapper .select-popout__toggle{border:1.5px solid #e0dbd8 !important;border-radius:8px !important;background:#fff !important;padding:13px 14px !important;width:100% !important;font-size:15px !important;height:auto !important;color:#333 !important;text-align:left !important}',
      '.selector-wrapper .select-popout__toggle:hover,.selector-wrapper .select-popout__toggle:focus{border-color:#5a3e6b !important}',
      '.bold_option_checkbox{display:block !important;margin-bottom:18px !important}',
      '.bold_option_checkbox label{display:flex !important;align-items:flex-start;gap:10px;margin:0 !important}',
      '.bold_option_checkbox .bold_option_element{display:inline-flex !important;align-items:flex-start;width:auto !important;margin:0 !important;flex:0 0 auto;padding-top:1px}',
      '.bold_option_checkbox .bold_option_title{display:inline-block !important;margin:0 !important;line-height:1.35;flex:1 1 auto;text-align:left}',
      '.bold_option_checkbox .bold_help_text{margin:6px 0 0 0 !important}',
      '.bold_option_checkbox input[type=checkbox]{width:18px !important;height:18px !important;accent-color:#5a3e6b;vertical-align:top !important;margin:0 !important;cursor:pointer;position:static !important}',
      '.bold_edit_in_cart{margin-top:8px}',
      '.bold_option_edit_container > div{display:flex;gap:10px;margin-top:12px;max-width:340px}',
      '.bold_option_edit_container button{flex:1;border-radius:8px !important;padding:12px 18px !important;font-size:14px !important;font-weight:600;cursor:pointer;min-height:44px;line-height:1.2}',
      '.bold_option_edit_container button:first-of-type{background:#5a3e6b !important;color:#fff !important;border:1.5px solid #5a3e6b !important}',
      '.bold_option_edit_container button:first-of-type:hover{background:#4a3258 !important}',
      '.bold_option_edit_container button:last-of-type{background:transparent !important;color:#6b6b6b !important;border:1.5px solid #e0dbd8 !important}',
      '.bold_option_edit_container button:last-of-type:hover{border-color:#9a9a9a !important}',
      '.cart__item__image{width:120px !important;max-width:120px !important;flex:0 0 120px;margin-right:18px}',
      '.cart__item__image img{width:100%}',
      '.cart__item__content{flex:1 1 0 !important;min-width:0 !important;width:auto !important;max-width:none !important}',
      '.header__cart__status{background:#412977 !important;color:#fff !important;min-width:17px;height:17px;border-radius:50% !important;font-size:10px !important;font-weight:700;display:flex;align-items:center;justify-content:center;padding:0 4px !important;line-height:1 !important}',
      '.bf-char-count{display:block;text-align:right;font-size:11px;color:#9a9a9a;margin-top:2px}',
      '.bf-trust{margin-top:14px;text-align:center;font-size:12px;color:#6b6b6b}',
      '.bf-trust__row{display:flex;align-items:center;justify-content:center;gap:6px;margin-bottom:8px}',
      '.bf-trust__chips{display:flex;justify-content:center;gap:6px;flex-wrap:wrap}',
      '.bf-trust__chip{border:1px solid #e0dbd8;border-radius:4px;padding:3px 8px;font-size:10px;font-weight:700;letter-spacing:.04em;color:#555;background:#fff}',
      '@media (max-width:768px){.cart__item__image{width:80px !important;max-width:80px !important;flex:0 0 80px;margin-right:12px}}',
      '@media (max-width:768px){.bold_option:not(:empty){margin-bottom:12px !important}.bold_option_title{margin:0 0 3px 0 !important}.bold_option_textbox .bold_option_element input[type=text],.bold_option_textarea .bold_option_element textarea{padding:11px 12px !important;font-size:16px !important}.bold_option_dropdown .bold_option_element select{padding:11px 36px 11px 12px !important;font-size:16px !important}.selector-wrapper{margin:0 0 12px 0 !important}.selector-wrapper .select-popout__toggle{padding:11px 12px !important;font-size:16px !important}.bfv-options{gap:6px}.bfv-swatch{padding:6px 13px 6px 7px;font-size:13px}.bfv-pill{padding:8px 14px;font-size:13px}.bfv-card{padding:11px 12px;min-width:110px}}',
      '.bold_cart_edit_button{background:transparent !important;border:1.5px solid #5a3e6b !important;color:#5a3e6b !important;border-radius:18px !important;padding:5px 16px !important;font-size:13px !important;font-weight:600;cursor:pointer;line-height:1.2;transition:.15s}',
      '.bold_cart_edit_button:hover{background:#5a3e6b !important;color:#fff !important}',
      '@media (max-width:768px){.bold_cart_edit_button{padding:9px 20px !important;min-height:40px}}',
      '.bfv-options{display:flex;flex-wrap:wrap;gap:8px;margin-top:2px}',
      '.bfv-card{flex:1 1 0;min-width:130px;border:2px solid #e0dbd8;border-radius:10px;padding:13px 14px;cursor:pointer;background:#fff;font-size:14px;text-align:center;transition:.15s;font-family:inherit}',
      '.bfv-card.bfv-sel{border-color:#5a3e6b;background:#f5f0fa;font-weight:600;color:#5a3e6b}',
      '.bfv-pill{border:2px solid #e0dbd8;border-radius:22px;padding:10px 18px;cursor:pointer;background:#fff;font-size:14px;transition:.15s;font-family:inherit}',
      '.bfv-pill.bfv-sel{border-color:#5a3e6b;background:#f5f0fa;font-weight:600;color:#5a3e6b}',
      '.bfv-swatch{display:flex;align-items:center;gap:8px;border:2px solid #e0dbd8;border-radius:26px;padding:7px 16px 7px 8px;cursor:pointer;background:#fff;font-size:14px;transition:.15s;font-family:inherit;white-space:nowrap}',
      '.bfv-swatch.bfv-sel{border-color:#5a3e6b;background:#f5f0fa;font-weight:600;color:#5a3e6b}',
      '.bfv-dot{width:24px;height:24px;border-radius:50%;border:1px solid rgba(0,0,0,.12);flex-shrink:0;display:inline-block}',
      '.bfv-hide{position:absolute !important;left:-9999px !important;top:0 !important;width:1px !important;max-width:1px !important;height:1px !important;overflow:hidden !important;opacity:0 !important;pointer-events:none !important}'
    ].join('\n');
    document.head.appendChild(st);
  }

  function build(sel, kind, o) {
    o = o || {};
    if (!sel || sel.dataset.bfvDone) return false;
    var list = [].slice.call(sel.options).filter(function (op) { return op.value && !/^--/.test((op.text || '').trim()); });
    if (!list.length) return false;
    sel.dataset.bfvDone = '1';
    var wrap = document.createElement('div'); wrap.className = 'bfv-options';
    list.forEach(function (op) {
      var b = document.createElement('button'); b.type = 'button';
      var label = (op.text || '').trim();
      if (kind === 'swatch') {
        var key = label.replace(/\s*\[.*$/, '');
        b.className = 'bfv-swatch';
        b.innerHTML = '<span class="bfv-dot" style="background:' + ((o.colors && o.colors[key]) || '#ccc') + '"></span>' + key;
      } else {
        b.className = (kind === 'pill' ? 'bfv-pill' : 'bfv-card');
        b.textContent = label;
      }
      if (op.value === sel.value) b.classList.add('bfv-sel');
      b.addEventListener('click', function () {
        sel.value = op.value;
        sel.dispatchEvent(new Event('input', { bubbles: true }));
        sel.dispatchEvent(new Event('change', { bubbles: true }));
        [].forEach.call(wrap.children, function (x) { x.classList.remove('bfv-sel'); });
        b.classList.add('bfv-sel');
      });
      wrap.appendChild(b);
    });
    sel.classList.add('bfv-hide');
    (o.mount || sel.parentNode).appendChild(wrap);
    return true;
  }

  var KNOWN_TONE_COLORS = { 'Silver': '#d7dce0', 'Gold': '#d9b45f', 'Rose Gold': '#d5a08d', 'Two Tone': 'two-tone' };

  function currentToneFromVariant() {
    var prod = window.__bfProdJSON;
    if (!prod) return null;
    var idEl = document.querySelector('[name="id"]');
    if (!idEl || !idEl.value) return null;
    var vid = String(idEl.value);
    for (var i = 0; i < prod.variants.length; i++) {
      var v = prod.variants[i];
      if (String(v.id) === vid) {
        var opts = [v.option1, v.option2, v.option3];
        for (var j = 0; j < opts.length; j++) {
          if (opts[j] && KNOWN_TONE_COLORS[opts[j]] !== undefined) return opts[j];
        }
      }
    }
    return null;
  }

  function toneSwatches() {
    document.querySelectorAll('.selector-wrapper').forEach(function (w) {
      if (w.dataset.bfvTone) return;
      var opts = [].slice.call(w.querySelectorAll('.select-popout__option'));
      if (!opts.length) return;
      var allKnown = opts.every(function (o) { return KNOWN_TONE_COLORS[o.textContent.trim()] !== undefined; });
      if (!allKnown) { w.dataset.bfvTone = 'skipped'; return; }
      var pop = w.querySelector('.select-popout'); if (pop) pop.classList.add('bfv-pop-hidden');
      var fs = w.querySelector('.select__fieldset') || w;
      var wrap = document.createElement('div'); wrap.className = 'bfv-options';
      var currentTone = currentToneFromVariant();
      var current = currentTone || (((w.querySelector('.select-popout__toggle') || {}).textContent) || '').trim();
      opts.forEach(function (o) {
        var label = o.textContent.trim();
        var col = KNOWN_TONE_COLORS[label] || '#ccc';
        var b = document.createElement('button'); b.type = 'button'; b.className = 'bfv-swatch';
        b.dataset.bfvVal = label;
        var dotStyle = (col === 'two-tone') ? 'background:linear-gradient(135deg,#d9b45f 50%,#d7dce0 50%)' : 'background:' + col;
        b.innerHTML = '<span class="bfv-dot" style="' + dotStyle + '"></span>' + label;
        if (current === label) b.classList.add('bfv-sel');
        b.addEventListener('click', function () { o.click(); [].forEach.call(wrap.children, function (x) { x.classList.remove('bfv-sel'); }); b.classList.add('bfv-sel'); });
        wrap.appendChild(b);
      });
      w.dataset.bfvTone = '1';
      fs.appendChild(wrap);
    });
  }

  var _boldMaxState = 0;
  var _boldMax = {};
  function applyMax(inp) {
    if (inp.maxLength > 0) return;
    var m = (inp.className || '').match(/(?:tb|ta)_(\d+)_/);
    if (m && _boldMax[m[1]]) inp.maxLength = _boldMax[m[1]];
  }
  function loadBoldMax() {
    if (_boldMaxState) return;
    var shop = window.Shopify && window.Shopify.shop;
    var pid = (window.__bfProdJSON && window.__bfProdJSON.id) ||
              (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product && ShopifyAnalytics.meta.product.id);
    if (!shop || !pid) return;
    _boldMaxState = 1;
    fetch('https://options.shopapps.site/v2/' + shop + '/generate_option/' + pid)
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var sets = (((j || {}).option_product) || {}).option_sets || [];
        sets.forEach(function (s) {
          (s.options || []).forEach(function (o) { if (o.max_size > 0) _boldMax[String(o.id)] = o.max_size; });
        });
        document.querySelectorAll('[data-bf-count]').forEach(function (inp) {
          applyMax(inp);
          inp.dispatchEvent(new Event('input', { bubbles: false }));
        });
      }).catch(function () {});
  }

  function charCounters() {
    loadBoldMax();
    document.querySelectorAll('.bold_option_textbox input[type=text], .bold_option_textarea textarea').forEach(function (inp) {
      if (inp.dataset.bfCount) return;
      inp.dataset.bfCount = '1';
      applyMax(inp);
      var c = document.createElement('span'); c.className = 'bf-char-count';
      function upd() {
        var max = inp.maxLength > 0 ? inp.maxLength : null;
        c.textContent = max ? (inp.value.length + '/' + max) : (inp.value.length ? inp.value.length + ' characters' : '');
        c.style.color = (max && inp.value.length >= max) ? '#b3261e' : '';
      }
      inp.addEventListener('input', upd);
      inp.parentNode.appendChild(c);
      upd();
    });
  }

  function run() {
    var f = document.querySelector('select[name="properties[Font Style]"]'); if (f) build(f, 'card', {});
    var c = document.querySelector('select[name="properties[Chain Length]"]'); if (c) build(c, 'pill', {});
    toneSwatches();
    charCounters();
  }

  function init() {
    injectCSS();
    var n = 0;
    var iv = setInterval(function () {
      n++; run();
      var f = document.querySelector('select[name="properties[Font Style]"]');
      var c = document.querySelector('select[name="properties[Chain Length]"]');
      var allTonesHandled = true;
      document.querySelectorAll('.selector-wrapper').forEach(function (w) { if (!w.dataset.bfvTone) allTonesHandled = false; });
      if (((!f || f.dataset.bfvDone) && (!c || c.dataset.bfvDone) && allTonesHandled) || n > 40) clearInterval(iv);
    }, 300);

    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') {
        var c2 = 0;
        var iv2 = setInterval(function () {
          c2++; run();
          if (window.__bfFilterTone) window.__bfFilterTone();
          if (c2 > 12) clearInterval(iv2);
        }, 120);
      }
    }, true);

    var ccPending = false;
    new MutationObserver(function () {
      if (ccPending) return; ccPending = true;
      setTimeout(function () { ccPending = false; charCounters(); }, 250);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();



/* ============================================================================
 * BF — Live price-with-extras  (v6)
 * ========================================================================== */
(function () {
  'use strict';

  function money(s) { var m = String(s).replace(/,/g, '').match(/(\d+(?:\.\d+)?)/); return m ? Math.round(parseFloat(m[1]) * 100) : 0; }

  var VMAP = null;
  function variantMap() {
    if (VMAP) return VMAP;
    var prod = window.__bfProdJSON || null;
    if (!prod) {
      [].slice.call(document.querySelectorAll('script[type="application/json"]')).forEach(function (s) {
        try { var j = JSON.parse(s.textContent); var v = j.variants || (j.product && j.product.variants); if (v) prod = j.variants ? j : j.product; } catch (e) {}
      });
    }
    if (!prod || !prod.variants) return null;
    VMAP = {};
    prod.variants.forEach(function (v) { VMAP[String(v.id)] = { price: v.price, compare: v.compare_at_price }; });
    return VMAP;
  }
  function selectedId() {
    var el = document.querySelector('form[action*="/cart/add"] [name="id"], form.product-form [name="id"], [name="id"]');
    if (el && el.value) return String(el.value);
    return new URLSearchParams(location.search).get('variant');
  }

  function extrasCents() {
    var t = document.querySelector('.bold_option_total');
    if (t && /\$\s*\d/.test(t.textContent || '')) return money(t.textContent);
    var sum = 0;
    document.querySelectorAll('.bold_option').forEach(function (o) {
      if (o.classList.contains('bold_option_hidden') || o.offsetParent === null) return;
      if (o.classList.contains('bold_option_checkbox')) {
        var cb = o.querySelector('input[type=checkbox]'); var p = o.querySelector('.bold_option_value_price');
        if (cb && cb.checked && p) sum += money(p.textContent);
      } else if (o.classList.contains('bold_option_dropdown')) {
        var sel = o.querySelector('select');
        if (sel && sel.options[sel.selectedIndex]) { var mm = sel.options[sel.selectedIndex].text.match(/\+\s*\$?(\d+(?:\.\d+)?)/); if (mm) sum += Math.round(parseFloat(mm[1]) * 100); }
      } else {
        var ci = o.querySelector('.bold_option_value input:checked, input[type=radio]:checked');
        if (ci) { var vp = ci.closest('.bold_option_value'); var p2 = vp ? vp.querySelector('.bold_option_value_price') : null; if (p2) sum += money(p2.textContent); }
      }
    });
    return sum;
  }

  function visible(el) { if (!el) return false; var r = el.getBoundingClientRect(); return r.width > 0 && r.height > 0 && !!el.offsetParent; }
  function firstVisible(list) { return [].slice.call(document.querySelectorAll(list)).filter(visible)[0] || null; }
  function saleEl() { return firstVisible('.product__content .price__sale .price-item--sale, .price__sale .price-item--sale, .product__content .price__regular .price-item--regular, .price__regular .price-item--regular'); }
  function strikeEl() { return firstVisible('.product__content .price__sale s.price-item--regular, .price__sale s.price-item--regular, .price__sale s'); }
  function fmt(cents) { var d = cents / 100; return '$' + (d % 1 === 0 ? d.toFixed(0) : d.toFixed(2)); }

  var lastSale = null, lastRRP = null, watched = null, domBase = null, lastId = null, pending = false;

  function schedule() {
    if (pending) return; pending = true;
    setTimeout(function () { pending = false; recompute(); }, 60);
  }
  function attachWatch(s) {
    var target = (s.closest && s.closest('.product__price, .price')) || s.parentNode || s;
    if (watched === target || !target) return;
    watched = target;
    new MutationObserver(schedule).observe(target, { childList: true, characterData: true, subtree: true });
  }

  function recompute() {
    var s = saleEl(); if (!s) return;
    var ex = extrasCents();
    var map = variantMap();
    var id = selectedId();
    if (id && map && map[id]) lastId = id;
    var v = map ? (map[id] || map[lastId] || null) : null;
    if (v) {
      var stxt = fmt(v.price + ex);
      if (s.textContent.trim() !== stxt) s.textContent = stxt; lastSale = stxt;
      var k = strikeEl();
      if (k && v.compare && v.compare > v.price) { var ktxt = fmt(v.compare + ex); if (k.textContent.trim() !== ktxt) k.textContent = ktxt; lastRRP = ktxt; }
    } else if (!map) {
      if (domBase === null || s.textContent.trim() !== lastSale) domBase = money(s.textContent);
      var stxt2 = fmt(domBase + ex);
      if (s.textContent.trim() !== stxt2) s.textContent = stxt2; lastSale = stxt2;
    }
    attachWatch(s);
  }

  function watchBold() {
    var c = document.querySelector('.bold_options, .bold_options_loaded');
    if (c && !c.dataset.bfPriceWatch) { c.dataset.bfPriceWatch = '1'; new MutationObserver(function () { recompute(); }).observe(c, { childList: true, subtree: true, characterData: true }); }
  }

  function init() {
    document.addEventListener('change', recompute, true);
    document.addEventListener('input', recompute, true);
    document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.bfv-swatch,.bfv-card,.bfv-pill,.select-popout__option,.bold_option')) setTimeout(recompute, 130); }, true);
    var n = 0;
    var iv = setInterval(function () { n++; recompute(); watchBold(); if (n > 60) clearInterval(iv); }, 400);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();



/* ===========================================================================
 * BF — Conditional options engine  (v5 — multi-match: hides ALL repeated fields)
 * ========================================================================= */
(function () {
  'use strict';

  function variantOffers(re) {
    return [].some.call(
      document.querySelectorAll('.selector-wrapper .select-popout__option, .selector-wrapper input[type=radio]'),
      function (el) { return re.test(el.textContent || el.value || ''); }
    );
  }

  var _prodVariants = null;
  function prodVariants() {
    if (_prodVariants) return _prodVariants;
    if (window.__bfProdJSON && window.__bfProdJSON.variants) {
      _prodVariants = window.__bfProdJSON.variants;
      return _prodVariants;
    }
    [].slice.call(document.querySelectorAll('script[type="application/json"]')).forEach(function (s) {
      try {
        var j = JSON.parse(s.textContent);
        var v = j.variants || (j.product && j.product.variants);
        if (v && !_prodVariants) _prodVariants = j.variants ? j.variants : j.product.variants;
      } catch (e) {}
    });
    return _prodVariants;
  }

  function variantSelected(re) {
    if ([].some.call(
      document.querySelectorAll('.selector-wrapper .select-popout__toggle, .selector-wrapper input[type=radio]:checked'),
      function (el) { return re.test(el.textContent || el.value || ''); }
    )) return true;
    try {
      var idEl = document.querySelector('[name="id"]');
      if (!idEl || !idEl.value) return false;
      var vid = String(idEl.value);
      var variants = prodVariants();
      if (!variants) return false;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (String(v.id) === vid) {
          return re.test([v.option1 || '', v.option2 || '', v.option3 || ''].join(' '));
        }
      }
    } catch (e) {}
    return false;
  }

  function boldAllByTitle(re) {
    return [].slice.call(document.querySelectorAll('.bold_option')).filter(function (o) {
      return re.test(((o.querySelector('.bold_option_title') || {}).textContent) || '');
    });
  }

  function setHidden(el, hide) {
    if (!el) return;
    if (hide) {
      if (el.dataset.bfCond === '1') return;
      el.dataset.bfCond = '1'; el.style.display = 'none';
      var s = el.querySelector('select'); if (s && s.selectedIndex !== 0) { s.selectedIndex = 0; s.dispatchEvent(new Event('change', { bubbles: true })); }
      var t = el.querySelector('input[type=text], textarea'); if (t && t.value !== '') { t.value = ''; t.dispatchEvent(new Event('input', { bubbles: true })); t.dispatchEvent(new Event('change', { bubbles: true })); }
      var fi = el.querySelector('input[type=file]'); if (fi && fi.value) { fi.value = ''; fi.dispatchEvent(new Event('change', { bubbles: true })); }
    } else if (el.dataset.bfCond === '1' || el.style.display === 'none') {
      el.dataset.bfCond = ''; el.style.display = '';
    }
  }

  var BIRTHSTONE   = /birthstone/i;
  var NONINSCRIBED = /\(\s*non[\s-]?inscribed\s*\)/i;
  var PHOTO        = /photo/i;

  function currentVariantOptionsText() {
    try {
      var idEl = document.querySelector('[name="id"]');
      if (!idEl || !idEl.value) return '';
      var variants = prodVariants();
      if (!variants) return '';
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(idEl.value))
          return [variants[i].option1 || '', variants[i].option2 || '', variants[i].option3 || ''].join(' ');
      }
    } catch (e) {}
    return '';
  }

  function ringCountRule() {
    var rm = currentVariantOptionsText().match(/(\d+)\s*Rings?\b/i);
    if (!rm) return;
    var nRings = parseInt(rm[1], 10);
    document.querySelectorAll('.bold_option').forEach(function (o) {
      var t = ((o.querySelector('.bold_option_title') || {}).textContent || '').trim();
      var km = t.match(/^Ring\s*(\d+)\b/i);
      if (km) setHidden(o, parseInt(km[1], 10) > nRings);
    });
  }

  function evaluate() {
    if (variantOffers(BIRTHSTONE))   boldAllByTitle(/birthstone/i).forEach(function (el) { setHidden(el, !variantSelected(BIRTHSTONE)); });
    if (variantOffers(NONINSCRIBED)) boldAllByTitle(/inscription|engraving/i).forEach(function (el) { setHidden(el, variantSelected(NONINSCRIBED)); });
    if (variantOffers(PHOTO))        boldAllByTitle(/photo/i).forEach(function (el) { setHidden(el, !variantSelected(PHOTO)); });
    ringCountRule();
  }

  function init() {
    document.addEventListener('change', function () { setTimeout(evaluate, 60); }, true);
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.select-popout__option,.bfv-swatch,.bfv-card,.bfv-pill'))
        setTimeout(evaluate, 140);
    }, true);
    var n = 0;
    var iv = setInterval(function () { n++; evaluate(); if (n > 50) clearInterval(iv); }, 400);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();



/* ============================================================================
 * BF — Cart line strike-price guard + authoritative totals  (v4)
 * ========================================================================= */
(function () {
  'use strict';
  function num(s) { var m = String(s).replace(/,/g, '').match(/(\d+(?:\.\d+)?)/); return m ? parseFloat(m[1]) : null; }
  function fmt(n) { return '$' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2)); }
  var lineData = null;
  var bfTotals = null;
  function loadCart() {
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      lineData = {};
      var items = 0;
      c.items.forEach(function (it) {
        var extras = 0;
        var bp = it.properties && it.properties._boldVariantPrices;
        if (bp) String(bp).split(',').forEach(function (x) { var v = parseFloat(x); if (!isNaN(v)) extras += v; });
        extras = extras / 100;
        var base = it.price / 100, final = it.final_price / 100;
        var discounted = it.final_price < it.price;
        lineData[it.key] = { base: base, extras: extras, qty: it.quantity, final: final, discounted: discounted };
        items += (discounted ? final : (base + extras)) * it.quantity;
      });
      var disc = 0;
      (c.cart_level_discount_applications || []).forEach(function (d) { disc += (d.total_allocated_amount || 0) / 100; });
      bfTotals = { items: items, subtotal: items - disc };
      fix();
    }).catch(function () {});
  }
  function setMoney(el, val) {
    if (!el) return;
    var t = fmt(val);
    var holder = null;
    [].slice.call(el.childNodes).forEach(function (n) {
      if (n.nodeType === 1 && n.classList && n.classList.contains('bold_cart_total')) return;
      if (n.nodeType === 1) { if (!holder) holder = n; else el.removeChild(n); }
      else if (n.nodeType === 3) { el.removeChild(n); }
    });
    if (!holder) { holder = document.createElement('span'); holder.className = 'bf-sub-money'; el.appendChild(holder); }
    if (holder.textContent !== t) holder.textContent = t;
  }
  function fixItemsRow() {
    if (!bfTotals) return;
    document.querySelectorAll('.cart__total__label').forEach(function (lab) {
      if (!/^items$/i.test(lab.textContent.trim())) return;
      var price = lab.parentElement.querySelector('.cart__total__price');
      if (price && num(price.textContent) !== bfTotals.items) price.textContent = fmt(bfTotals.items);
    });
    setMoney(document.querySelector('.cart__total__price--animated, [data-cart-total]'), bfTotals.subtotal);
  }
  function addTrustRow() {
    document.querySelectorAll('.cart__buttons__fieldset').forEach(function (fs) {
      if (fs.dataset.bfTrust) return;
      fs.dataset.bfTrust = '1';
      var d = document.createElement('div');
      d.className = 'bf-trust';
      d.innerHTML =
        '<div class="bf-trust__row">' +
        '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#6b6b6b" stroke-width="2" aria-hidden="true"><rect x="4" y="11" width="16" height="9" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>' +
        '<span>Secure encrypted checkout</span></div>' +
        '<div class="bf-trust__chips"><span class="bf-trust__chip">VISA</span><span class="bf-trust__chip">Mastercard</span><span class="bf-trust__chip">Afterpay</span><span class="bf-trust__chip">Zip</span></div>';
      fs.insertAdjacentElement('afterend', d);
    });
  }
  function fix() {
    document.querySelectorAll('.cart__price').forEach(function (p) {
      var ins = p.querySelector('ins'), del = p.querySelector('del');
      if (!ins || !del) return;
      var keyEl = p.querySelector('.bold_cart_item_price');
      var key = keyEl ? keyEl.getAttribute('data-item-key') : null;
      var d = (lineData && key) ? lineData[key] : null;
      if (!del.dataset.bfBase) del.dataset.bfBase = num(del.textContent);
      var d0 = parseFloat(del.dataset.bfBase);
      if (isNaN(d0)) return;
      if (d) {
        if (d.discounted) return;
        var full = d.base + d.extras;
        if (num(ins.textContent) !== full) ins.textContent = fmt(full);
        var target = d0 + d.extras;
        if (num(del.textContent) !== target) del.textContent = fmt(target);
        del.style.display = (target > full) ? '' : 'none';
      } else {
        var i = num(ins.textContent);
        if (i == null) return;
        del.style.display = (d0 > i) ? '' : 'none';
      }
    });
    fixItemsRow();
    addTrustRow();
  }
  function init() {
    loadCart();
    var pend = false;
    new MutationObserver(function () {
      if (pend) return; pend = true;
      setTimeout(function () {
        pend = false;
        if (document.querySelector('.cart__price, .cart__total__label')) loadCart();
      }, 450);
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('change', function () { setTimeout(loadCart, 300); }, true);
    var n = 0; var iv = setInterval(function () { n++; fix(); if (n > 20) clearInterval(iv); }, 500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();



/* ============================================================================
 * BF — Cart UX: count refresh on Back + Add-to-cart loading state  (v1)
 * ========================================================================= */
(function () {
  'use strict';
  function setCount(n) { document.querySelectorAll('cart-count, .header__cart__status').forEach(function (el) { if (el.children.length === 0) el.textContent = n; }); }
  function refresh() { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); return c.item_count; }).catch(function () { return null; }); }
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  window.addEventListener('focus', function () { refresh(); });

  if (!document.getElementById('bf-atc-css')) {
    var css = document.createElement('style'); css.id = 'bf-atc-css';
    css.textContent = '.bf-atc-loading{position:relative !important;pointer-events:none !important;opacity:.85}.bf-atc-loading::after{content:"";position:absolute;top:50%;right:16px;width:16px;height:16px;margin-top:-8px;border:2px solid rgba(255,255,255,.55);border-top-color:#fff;border-radius:50%;animation:bf-spin .7s linear infinite}@keyframes bf-spin{to{transform:rotate(360deg)}}';
    document.head.appendChild(css);
  }
  function loading(btn) {
    if (btn.dataset.bfLoading) return;
    btn.dataset.bfLoading = '1'; btn.classList.add('bf-atc-loading');
    var base = parseInt((document.querySelector('cart-count, .header__cart__status') || {}).textContent || '0', 10) || 0;
    var n = 0;
    var iv = setInterval(function () {
      n++;
      refresh().then(function (count) {
        if ((count != null && count > base) || n > 22) { clearInterval(iv); btn.classList.remove('bf-atc-loading'); btn.dataset.bfLoading = ''; }
      });
    }, 400);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button[name=add], .bold_clone, .product-form__submit, [data-add-to-cart]');
    if (b && /add to (cart|bag)/i.test(b.textContent || '')) loading(b);
  }, true);
})();



/* ============================================================================
 * BF — Variant-aware option filtering  (v4 — availability-aware, any position)
 * ========================================================================= */
(function () {
  'use strict';

  function currentVariant(prod) {
    var idEl = document.querySelector('[name="id"]');
    if (!idEl || !idEl.value) return null;
    for (var i = 0; i < prod.variants.length; i++) {
      if (String(prod.variants[i].id) === String(idEl.value)) return prod.variants[i];
    }
    return null;
  }

  function filterTone() {
    var prod = window.__bfProdJSON;
    if (!prod || !prod.variants || !prod.options) return;
    var cur = currentVariant(prod);

    document.querySelectorAll('.selector-wrapper[data-bfv-tone="1"] .bfv-options').forEach(function (wrap) {
      var swatchVals = [].map.call(wrap.children, function (btn) {
        return btn.dataset.bfvVal || btn.textContent.trim();
      });

      var optIndex = -1;
      for (var i = 0; i < prod.options.length; i++) {
        var vals = prod.options[i].values || [];
        if (swatchVals.some(function (v) { return vals.indexOf(v) !== -1; })) { optIndex = i; break; }
      }
      if (optIndex === -1) return;

      var hadSelection = false;
      [].forEach.call(wrap.children, function (btn) {
        var val = btn.dataset.bfvVal || btn.textContent.trim();
        var ok = prod.variants.some(function (v) {
          if (v.available === false) return false;
          var o = [v.option1, v.option2, v.option3];
          if (o[optIndex] !== val) return false;
          if (cur) {
            var c = [cur.option1, cur.option2, cur.option3];
            for (var k = 0; k < prod.options.length; k++) {
              if (k !== optIndex && c[k] && o[k] !== c[k]) return false;
            }
          }
          return true;
        });
        btn.style.display = ok ? '' : 'none';
        if (!ok && btn.classList.contains('bfv-sel')) btn.classList.remove('bfv-sel');
        if (ok && btn.classList.contains('bfv-sel')) hadSelection = true;
      });

      if (!hadSelection) {
        var first = null;
        for (var i = 0; i < wrap.children.length; i++) {
          if (wrap.children[i].style.display !== 'none') { first = wrap.children[i]; break; }
        }
        if (first) first.click();
      }
    });
  }

  function init() {
    window.__bfFilterTone = filterTone;
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') setTimeout(filterTone, 80);
    }, true);
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.select-popout__option')) setTimeout(filterTone, 220);
    }, true);
    var n = 0;
    var iv = setInterval(function () {
      n++; filterTone();
      var swatchesReady = !!document.querySelector('.selector-wrapper[data-bfv-tone="1"] .bfv-options');
      if ((window.__bfProdJSON && swatchesReady) || n > 50) clearInterval(iv);
    }, 350);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();


/* ============================================================================
 * BF — Judge.me v3 preview-badge star fallback  (v1)
 * ========================================================================= */
(function () {
  'use strict';
  function fallback() {
    var st = document.createElement('style');
    st.id = 'bf-jdgm-fallback';
    st.textContent = [
      '.jdgm-prev-badge{display:block !important}',
      '.jdgm-prev-badge .jdgm-star{font-family:inherit !important;font-style:normal;color:var(--jdgm-star-color,#654aa1);font-size:16px;line-height:1;letter-spacing:2px}',
      '.jdgm-prev-badge .jdgm-star.jdgm--on:after{content:"★"}',
      '.jdgm-prev-badge .jdgm-star.jdgm--half:after{content:"★";opacity:.55}',
      '.jdgm-prev-badge .jdgm-star.jdgm--off:after{content:"☆"}'
    ].join('\n');
    document.head.appendChild(st);
  }
  function check() {
    if (document.getElementById('bf-jdgm-fallback')) return true;
    var b = document.querySelector('.jdgm-prev-badge');
    if (!b) return false;
    var star = b.querySelector('.jdgm-star');
    if (!star) return false;
    var rating = parseFloat(b.getAttribute('data-average-rating') || '0');
    var reviews = parseInt(b.getAttribute('data-number-of-reviews') || '0', 10);
    if (!rating || !reviews) { b.style.display = 'none'; return true; }
    var hidden = getComputedStyle(b).display === 'none';
    var w = star.getBoundingClientRect().width;
    if (hidden || w < 2) { fallback(); return true; }
    return true;
  }
  function init() {
    var n = 0;
    var iv = setInterval(function () { n++; if ((n > 3 && check()) || n > 20) clearInterval(iv); }, 700);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();


/* ============================================================================
 * BF — File-upload add-to-cart rescue  (v1)
 * ========================================================================= */
(function () {
  'use strict';
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (!form.querySelector('input[type="file"]')) return;
    e.stopPropagation();
    if (form.enctype !== 'multipart/form-data') form.enctype = 'multipart/form-data';
    [].forEach.call(form.querySelectorAll('[name^="properties"]'), function (el) { el.disabled = false; });
  }, true);
})();
